import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * An HTTP Response from Transport.
 *
 * @typeParam T - The type of the `body` field.
 */
export var HTTPResponse =
/*#__PURE__*/
function () {
  /**
   * @param url - An optional URL for the response.
   * @param status - An optional status for the response;
   */
  function HTTPResponse(url) {
    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, HTTPResponse);

    /**
     * The resolved URL of the response.
     */
    this.url = '';
    /**
     * The status code of the response.
     */

    this.status = 0;
    /**
     * The response headers.
     *
     * This field is null unless the request was made with
     * `options.parseResponseHeaders` set to true.
     */

    this.headers = null;
    /**
     * The body of the response, or null if there is no body.
     *
     * The type of this field is dependent on the `options.responseType` value set
     * in the request. If the `responseType` is `'json'`, the type of this value
     * will also depend on whether the request was type-hinted.
     */

    this.body = null;
    /**
     * A flag that indicates whether the navigator was online when the request
     * response was sent.
     */

    this.offline = false;
    /**
     * A timers object for the response.
     */

    this.timing = null;
    /**
     * Data that was included in the request.
     */

    this.metadata = null;
    /**
     * The retries counter.
     */

    this.retries = {
      count: 0
    };
    this.url = url;
    this.status = status;
    this.ok = status >= 200 && status <= 299;
  }
  /**
   * Return the status family of the status code.
   *
   * @returns The status family of the response.
   */


  _createClass(HTTPResponse, [{
    key: "getStatusFamily",
    value: function getStatusFamily() {
      return 0 | this.status / 100;
    }
  }]);

  return HTTPResponse;
}();